import { Box, Typography } from '@mui/material';

import { Button, ButtonProps } from '@/components';

import { SECTION_TITLE_VARIANT } from '../../styles';

interface TileHeaderProps {
  title: string;
  description: string;
  buttonProps?: ButtonProps<'button'>;
  grow?: boolean;
}

export const TileHeader = ({
  title,
  description,
  buttonProps,
  grow,
}: TileHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
        flexGrow: grow ? 1 : 0,
        position: 'relative',
      }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant={SECTION_TITLE_VARIANT}>{title}</Typography>
        <Typography variant="caption1">{description}</Typography>
      </Box>
      {buttonProps && (
        <Button
          fullWidth={false}
          size="small"
          label="Download CSV"
          {...buttonProps}
          sx={{
            position: {
              xs: 'absolute',
              md: 'static',
            },
            right: -12,
            top: -8,
          }}
        />
      )}
    </Box>
  );
};
